const SET_CAPEX_DATA = (state, data) => {
  state.capexData = data
}

const SET_ERROR_REQUEST_CAPEX = (state, isError) => {
  state.errorRequestCapex = isError
}

const SET_ERROR_UPLOAD_FILE = (state, { isError, message = null }) => {
  state.errorUploadFile = isError
  state.errorUploadFileKey = message
}

const SET_UPLOADED_FILE_SUCCESS = (state, isSuccess) => {
  state.uploadedFileSuccess = isSuccess
}

const SET_ERROR_DOWNLOAD_FILE = (state, isError) => {
  state.errorDownloadFile = isError
}

const SET_DOWNLOAD_CAPEX_FILE = (state, file) => {
  state.blobFile = file
}

export default {
  SET_CAPEX_DATA,
  SET_ERROR_REQUEST_CAPEX,
  SET_ERROR_UPLOAD_FILE,
  SET_UPLOADED_FILE_SUCCESS,
  SET_ERROR_DOWNLOAD_FILE,
  SET_DOWNLOAD_CAPEX_FILE,
}
